// Import 3rd party libraries from node_modules
// ex.: import React from 'react';

// Global namespace
import {createApp} from 'vue';
import VueSplide from '@splidejs/vue-splide';
import {createPinia} from 'pinia';
import components from './vue/components/product';
import '../styles/main.css';

// Import as function from module exports
// ex.: use import from to init manually the module
import labBranding from './modules/lab_branding';
import cart from './modules/cart';
import currency from './modules/currency';
import modals from './modules/modal_popup';
import utils from './modules/utils';
import tracker from './modules/tracking';

const pinia = createPinia();

theme.cart = cart;
theme.currency = currency;
theme.modalPopup = modals;
theme.tracker = tracker;
theme.utils = utils;

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

/* Create Vue instance function */
const createVueApp = () => {
  const app = createApp({});

  // register components
  Object.entries(components.components).forEach((component) => {
    const [name, module] = component;
    app.component(name, module);
  });

  // register plugins
  app.use(VueSplide);
  app.use(pinia);

  // change delimiters to use Vue inside liquid files
  app.config.compilerOptions.delimiters = ['{$', '$}'];

  /*
  app.config.errorHandler = (err, instance, info) => {
    console.log('err:', err);
    console.log('instance:', instance);
    console.log('info:', info);
  };
  */

  return app;
};

/* create and mount Vue instance(s) */
const appElement = document.querySelector('#page-container');

if (appElement) {
  createVueApp().mount(appElement);
} else {
  const vueElements = document.querySelectorAll('[vue]');

  if (vueElements) {
    vueElements.forEach((el) => {
      createVueApp().mount(el);
    });
  }
}

/* properly render vue components on user insert in the theme editor */
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.value.includes('vue')) {
      createVueApp().mount(event.target);
    }
  });
} else if (!Shopify.designMode && process.env.NODE_ENV === 'development') {
  /* reload the current page to rerender async inserted sections with vue components */
  new MutationObserver((mutationsList) => {
    mutationsList.forEach((record) => {
      const vue = Array.from(record.addedNodes).find(
        (node) => node.classList && node.classList.value.includes('vue')
      );

      if (vue) window.location.reload();
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
  });
}

/** ********************************************************************************** */
/** ********************************DO NOT EDIT BELOW********************************* */
/** ********************************************************************************** */

// Init Main Javascript
theme.initMain = () => {
  // lab branding
  labBranding();
};

/**
 * Custom DOMready function
 * @param {*} callback
 */
theme.DOMready = (callback) => {
  if (document.readyState !== 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
};

/**
 * Use this event listener to run your JS after the DOM is ready
 */
theme.DOMready(() => {
  // Init Main JS
  theme.initMain();

  // dispatch customEvent
  document.dispatchEvent(new CustomEvent('page:loaded'));
});
